export const isHttpSuccess = (status: number): boolean => {
  return status === 200 || status === 204;
};
